import React from 'react';
import PropTypes from 'prop-types';
import { Image } from '@leegality/leegality-react-component-library';
import useTranslation from '../../../utils/translation-utils';

const ImageWrapper = ({
  src, alt, onLoad, className,
}) => {
  const [getTranslation] = useTranslation();
  return (
    <Image
      src={src}
      onLoad={onLoad}
      className={className}
      alt={getTranslation(alt)}
    />
  );
};

ImageWrapper.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  onLoad: PropTypes.func,
  className: PropTypes.string,
};

ImageWrapper.defaultProps = {
  src: '',
  alt: '',
  className: '',
  onLoad: () => {},
};

export {
  ImageWrapper as default,
};
